import React, { useState } from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import { Icon } from '@iconify/react';
import emailjs from '@emailjs/browser';

export default function ContactPage() {
  pageTitle('Contact');
  
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    projectBrief: ''
  });
  
  const [status, setStatus] = useState({
    submitting: false,
    message: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, message: null });

    try {
      const response = await emailjs.send(
        'EMAILJS_SERVICE_ID', // Replace with your EmailJS service ID
        'EMAILJS_TEMPLATE_ID', // Replace with your EmailJS template ID
        {
          from_name: formData.fullName,
          from_email: formData.email,
          phone_number: formData.phone,
          project_brief: formData.projectBrief,
          to_email: 'info@soketrysolutions.co.ke',
        },
        'EMAILJS_PUBLIC_KEY' // Replace with your EmailJS public key
      );

      if (response.status === 200) {
        setStatus({
          submitting: false,
          message: { type: 'success', text: 'Thank you! We will get back to you soon.' }
        });
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          projectBrief: ''
        });
      }
    } catch (error) {
      console.error('Email sending failed:', error);
      setStatus({
        submitting: false,
        message: { type: 'error', text: 'Failed to send message. Please try again.' }
      });
    }
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Get in touch for more <br/>information and support"
        subTitle="Contact"
        shape="shape_6"
      />
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              <h2 className="cs_fs_50">
                Come & visit <br />
                our place!
              </h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Email:</h3>
                  <p className="mb-0">
                    <a 
                      href="mailto:info@soketrysolutions.co.ke"
                      className="cs_contact_link"
                      title="Send us an email"
                    >
                      info@soketrysolutions.co.ke
                    </a>
                  </p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Phone:</h3>
                  <p className="mb-0">
                    <a 
                      href="tel:+254790915190"
                      className="cs_contact_link"
                      title="Call us"
                    >
                      +254 790 915 190
                    </a>
                  </p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Address:</h3>
                  <p className="mb-0">Nairobi, Kenya</p>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" />
                <form className="cs_contact_form" onSubmit={handleSubmit}>
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Your full name
                  </label>
                  <input
                    name="fullName"
                    placeholder="Type your name"
                    type="text"
                    className="cs_form_field"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Give valid email
                  </label>
                  <input
                    name="email"
                    placeholder="Type your email address"
                    type="email"
                    className="cs_form_field"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Phone number
                  </label>
                  <input
                    name="phone"
                    placeholder="Type your phone number"
                    type="tel"
                    className="cs_form_field"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Project brief
                  </label>
                  <textarea
                    name="projectBrief"
                    cols={30}
                    rows={5}
                    className="cs_form_field"
                    value={formData.projectBrief}
                    onChange={handleChange}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  
                  {status.message && (
                    <div className={`cs_alert cs_alert_${status.message.type}`}>
                      {status.message.text}
                    </div>
                  )}
                  
                  <button 
                    className="cs_btn cs_style_1"
                    type="submit"
                    disabled={status.submitting}
                  >
                    {status.submitting ? 'Sending...' : 'Submit for Quotation'}{' '}
                    <span>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="cs_height_0 cs_height_lg_80" />
      </section>
      <div className="cs_map">
        <iframe
          id="map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3988.957166187191!2d36.93219414634559!3d-1.1904449932721917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2ske!4v1736043561348!5m2!1sen!2ske"
          allowFullScreen
          title="Google Map"
        />
      </div>
    </>
  );
}
